import React from 'react';

import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import { Tooltip, useTheme, IconButton, useMediaQuery } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

// ----------------------------------------------------------------

type DLXDriveBulkActionComponentIconButtonProps = {
  isDisabled: boolean;
  icon: string;
  tooltipTitle: string;
  onClick: () => void;
  id: string;
};

const DLXDriveBulkActionComponentIconButton: React.FC<
  DLXDriveBulkActionComponentIconButtonProps
> = ({ isDisabled, icon, tooltipTitle, onClick, id }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  const fontSize = isMobile ? 'small' : 'medium';

  const getIcon = () => {
    switch (icon) {
      case 'archive':
        return <ArchiveIcon fontSize={fontSize} />;
      case 'download':
        return <FileDownloadIcon fontSize={fontSize} />;
      case 'signature':
        return <DriveFileRenameOutlineIcon fontSize={fontSize} />;
      case 'approve':
        return <CheckCircleOutlineIcon fontSize={fontSize} />;
      case 'share':
        return <ShareIcon fontSize={fontSize} />;
      case 'move':
        return <DriveFileMoveIcon fontSize={fontSize} />;
      case 'delete':
        return <DeleteIcon fontSize={fontSize} />;
      default:
        return <FileDownloadIcon fontSize={fontSize} />;
    }
  };

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <IconButton
        size="small"
        disabled={isDisabled}
        onClick={onClick}
        id={id}
        sx={{
          backgroundColor: theme.palette.grey[800],
          color: theme.palette.grey[500],
          '&:hover': {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[400],
          },
        }}
      >
        {getIcon()}
      </IconButton>
    </Tooltip>
  );
};

export default DLXDriveBulkActionComponentIconButton;
